import { jsx as a, jsxs as m, Fragment as f } from "react/jsx-runtime";
import { useState as _, useEffect as u } from "react";
import { useTranslation as v, useSession as g, useNextgenRouter as V, FAIcon as z, Theme as e, IconStyle as C, Tag as h, TagStyle as k, TagWidth as q } from "@nextgen-web-framework/all";
import { UrlKeyEnum as y } from "./utils/common.js";
import './assets/VerticalTabNavigationItem.css';const B = "#ffffff", R = "#396e75", T = "#e5fdff", w = "#546223", O = "#f0fae5", N = "#a65523", A = "#fff1e8", G = "#7f3e3e", P = "#ffe2e2", S = "#62625a", W = "#f8f8e7", I = "#38539a", x = "#707070", E = "#c8f8d1", L = "#87c9c8", $ = "#5291b1", U = "rgba(82, 145, 177, 0.1019607843)", Y = "#445685", F = "#181d61", K = "rgba(24, 29, 97, 0.1019607843)", j = "#5969d6", D = "#ea999d", H = "#b6577e", J = "rgba(182, 87, 126, 0.1019607843)", M = "#7e3e80", Q = "#1e247f", X = "rgba(30, 36, 127, 0.1019607843)", Z = "#da7600", p = "#107f47", tt = "#d91734", at = "_html_8ifqa_75", i = {
  amwayWhite: B,
  darkBlue: R,
  lightBlue: T,
  darkGreen: w,
  lightGreen: O,
  darkOrange: N,
  lightOrange: A,
  darkRed: G,
  lightRed: P,
  darkYellow: S,
  lightYellow: W,
  darkPurple: I,
  darkGrayOnWhite: x,
  dataVizColor1: E,
  dataVizColor2: L,
  dataVizColor3: $,
  dataVizColor3Background: U,
  dataVizColor4: Y,
  dataVizColor5: F,
  dataVizColor5Background: K,
  dataVizColor6: j,
  dataVizColor7: D,
  dataVizColor8: H,
  dataVizColor8Background: J,
  dataVizColor9: M,
  dataVizColor10: Q,
  dataVizColor10Background: X,
  dataVizAlertOrange: Z,
  dataVizSuccessGreen: p,
  dataVizWarningRed: tt,
  "no-visible": "_no-visible_8ifqa_34",
  html: at,
  "vertical-tab-container": "_vertical-tab-container_8ifqa_142",
  "vertical-tab-site-tabs-content": "_vertical-tab-site-tabs-content_8ifqa_148",
  "vertical-tab-site-tabs-account": "_vertical-tab-site-tabs-account_8ifqa_157",
  "vertical-tab-content": "_vertical-tab-content_8ifqa_166",
  "vertical-tab-mobile-content": "_vertical-tab-mobile-content_8ifqa_175",
  "vertical-tab-full-content": "_vertical-tab-full-content_8ifqa_182",
  "vertical-tab-list-item-content": "_vertical-tab-list-item-content_8ifqa_191",
  "vertical-tab-list-item-account": "_vertical-tab-list-item-account_8ifqa_206",
  "vertical-tab-list-item-icon": "_vertical-tab-list-item-icon_8ifqa_221",
  "vertical-tab-list-item": "_vertical-tab-list-item_8ifqa_191",
  "vertical-tab-active-item": "_vertical-tab-active-item_8ifqa_233"
}, ct = (t) => {
  const [l, c] = _(!1), n = v(), { session: r } = g(), { primaryProfile: d } = r, s = V(), o = () => {
    (t == null ? void 0 : t.target) === "_blank" ? window.open(t == null ? void 0 : t.url, "_blank") : s.push(t == null ? void 0 : t.url);
  };
  u(() => {
    c(t.url === t.activeRoute);
  }, [t.activeRoute]);
  const b = d ? "coapplicant" : "primary";
  return /* @__PURE__ */ a(
    "div",
    {
      "data-testid": "vertical-tab-testid",
      "data-pod-name": "commerce",
      role: "button",
      tabIndex: 0,
      "aria-label": "vertical tab",
      onClick: o,
      onKeyDown: o,
      children: /* @__PURE__ */ m(
        "div",
        {
          "data-testid": "vertical-tab-list-item-test-id",
          "data-pod-name": "commerce",
          id: `vertical-tab-list-item-${t.label}-id`,
          className: `${i[`vertical-tab-list-item-${t.source}`]} ${l ? i["vertical-tab-active-item"] : ""}`,
          children: [
            t.iconName && /* @__PURE__ */ a("div", { className: i["vertical-tab-list-item-icon"], children: /* @__PURE__ */ a(
              z,
              {
                theme: l ? e.PURPLE : e.BLACK,
                iconName: t.iconName,
                iconStyle: C.REGULAR
              }
            ) }),
            t.label,
            t.url.includes(y.CO_APPLICANT) && /* @__PURE__ */ a(f, { children: /* @__PURE__ */ a(
              h,
              {
                style: k.SOLID,
                tagWidth: q.FIT_CONTENT,
                text: n(`web.tag.${b}`),
                theme: e.PURPLE,
                "data-testid": "owner-tag",
                "data-pod-name": "commerce"
              }
            ) })
          ]
        }
      )
    },
    t == null ? void 0 : t.url
  );
};
export {
  ct as V,
  i as s
};
//# sourceMappingURL=VerticalTabNavigationItem-0e7b0085.mjs.map
